<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c3.31,0,6,2.69,6,6l0,0c0,3.31-2.69,6-6,6l0,0c-3.31,0-6-2.69-6-6l0,0c0-0.29,0.02-0.56,0.06-0.83l0,0.03
	c0.35,2.16,2.2,3.79,4.44,3.8l0,0c2.49,0,4.5-2.02,4.5-4.5l0,0c0-2.24-1.63-4.09-3.77-4.44l-0.03,0
	C-0.06,782.52,0.22,782.5,0.5,782.5L0.5,782.5z M8.5,795.5v4.86c0.69,0.34,1.36,0.71,2,1.14l-1,1c-4-3-14-3-18,0l-1-1
	c0.64-0.43,1.32-0.8,2-1.14v-2.86h2v2.02c2.57-0.9,5.31-1.2,8-0.9v-1.12h2v1.45c0.34,0.07,0.67,0.16,1,0.26v-3.7H8.5L8.5,795.5z"/>
</svg>

</template>